module.exports = __webpack_public_path__ + "img/noicon.51177d70.svg";